import React, {useImperativeHandle} from 'react';
import {Box, makeStyles} from '@material-ui/core';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
  fullWidth: {
    width: '100%',
  },
  appMainContent: {
    width: '100%',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    boxSizing: 'border-box',
    padding: '0px',
    [theme.breakpoints.up('md')]: {
      paddingLeft: 0,
      paddingRight: 0,
    },
    [theme.breakpoints.up('lg')]: {
      paddingLeft: 0,
      paddingRight: 0,
    },
    [theme.breakpoints.up('xl')]: {
      paddingLeft: 0,
      paddingRight: 0,
    },
    [theme.breakpoints.down('sm')]: {
      paddingTop: 0,
      paddingBottom: 0,
    },
  },
}));

const CmtContent = React.forwardRef(function LayoutContent(props, ref) {
  const {children} = props;
  useImperativeHandle(ref, () => ({}));

  const contentRef = React.createRef();
  const classes = useStyles();

  return (
    <Box
      ref={contentRef}
      className={clsx(
        classes.appMainContent,
        // fullScreen ? classes.fullWidth : "",
        'Cmt-appMainContent',
      )}
      bgcolor="background.main"
    >
      {children}
    </Box>
  );
});

export default CmtContent;
CmtContent.defaultProps = {
  name: 'LayoutContent',
};
